import React from 'react';
import { Icon, DropdownItem, Col } from '@vfpf/vfpf-shared';
import { Dropdown as BootstrapDropdown, Anchor } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

type CustomToggleProps = {
  children: React.ReactNode;
  onClick: Function;
};

const CustomToggle = React.forwardRef((props: CustomToggleProps, ref) => {
  const { children, onClick } = props;

  return (
    <Anchor
      className="dropdown-toggle"
      data-toggle="dropdown"
      href=""
      role="button"
      aria-label="Account menu"
      aria-haspopup="true"
      ref={ref as React.RefObject<HTMLAnchorElement>}
      onClick={(e): void => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </Anchor>
  );
});

CustomToggle.displayName = 'CustomToggle';

export const LogoutDropdown: React.FC = () => {
  const history = useHistory();

  const handleOnClick = () => {
    history.push('/uitloggen');
  };

  return (
    <Col textAlign="right" className="col" variant="ssa">
      <BootstrapDropdown className="navbar-top-right col-auto">
        <BootstrapDropdown.Toggle id="dropdownMenuLink" as={CustomToggle}>
          <Icon iconClass="icon-user mr-1" />
        </BootstrapDropdown.Toggle>
        <BootstrapDropdown.Menu className="user-menu" align={"end"} >
          <>
            <DropdownItem key={'Uitloggen'} onClick={(): void => handleOnClick()}>
              <Icon iconClass={'icon-external'} />
              Uitloggen
            </DropdownItem>
          </>
        </BootstrapDropdown.Menu>
      </BootstrapDropdown>
    </Col>
  );
};
